import { render, staticRenderFns } from "./GoodsData.vue?vue&type=template&id=242fdf34"
import script from "./GoodsData.vue?vue&type=script&lang=ts"
export * from "./GoodsData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ShowTabsDettaglioPvpGoodsBeneUbicazione: require('/usr/src/nuxt-app/components/show/tabs/dettaglioPvp/goods/BeneUbicazione.vue').default,ShowTabsDettaglioPvpGoodsBeneImmobile: require('/usr/src/nuxt-app/components/show/tabs/dettaglioPvp/goods/BeneImmobile.vue').default,ShowTabsDettaglioPvpGoodsBeneMobile: require('/usr/src/nuxt-app/components/show/tabs/dettaglioPvp/goods/BeneMobile.vue').default,ShowTabsDettaglioPvpGoodsBeneAzienda: require('/usr/src/nuxt-app/components/show/tabs/dettaglioPvp/goods/BeneAzienda.vue').default})
